(() => {
  'use strict';
  const init = (scope = document) => {
    scope.querySelectorAll('[data-st-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; }));
      document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
    });
    scope.querySelectorAll('[data-st-pdp]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const image = root.querySelector('[data-st-main-image]');
      const imageLink = root.querySelector('[data-st-image-link]');
      root.querySelectorAll('[data-st-thumb]').forEach(button => {
        button.addEventListener('click', () => {
          if (!image) return;
          image.src = button.dataset.src;
          image.srcset = button.dataset.srcset || '';
          image.alt = button.dataset.alt || '';
          if (imageLink) imageLink.href = button.dataset.full;
          root.querySelectorAll('[data-st-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      const form = root.querySelector('form[data-st-product-form]');
      if (!form) return;
      const quantity = form.querySelector('[name="quantity"]');
      root.querySelectorAll('[data-st-quantity]').forEach(button => button.addEventListener('click', () => {
        if (!quantity) return;
        try { Number(button.dataset.stQuantity) > 0 ? quantity.stepUp() : quantity.stepDown(); } catch (_) { quantity.value = quantity.min || '1'; }
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      const selector = form.querySelector('select[name="id"]');
      const sticky = root.querySelector('[data-st-sticky]');
      const buttons = root.querySelectorAll('[data-st-add]');
      const synchronize = () => {
        if (!selector) return;
        const option = selector.options[selector.selectedIndex];
        const available = option.dataset.available === 'true';
        root.querySelectorAll('[data-st-price]').forEach(el => { el.textContent = option.dataset.price; });
        root.querySelectorAll('[data-st-add]').forEach(button => { button.disabled = !available; button.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel; });
        root.querySelectorAll('[data-st-availability]').forEach(el => { el.hidden = available; });
        root.querySelectorAll('[data-st-savings]').forEach(el => { el.textContent = option.dataset.savings || ''; el.hidden = !option.dataset.savings; });
        const accelerated = root.querySelector('[data-st-accelerated]');
        if (accelerated) accelerated.hidden = !available;
        if (quantity) {
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        if (option.dataset.image && image) { image.src = option.dataset.image; image.srcset = ''; if (imageLink) imageLink.href = option.dataset.image; }
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      };
      if (selector) selector.addEventListener('change', synchronize);
      if (sticky) {
        const buyRow = root.querySelector('[data-st-buy-row]');
        let queued = false;
        const updateSticky = () => {
          queued = false;
          if (!root.isConnected) return;
          const show = matchMedia('(max-width:900px)').matches && buyRow && buyRow.getBoundingClientRect().bottom < 80 && !document.querySelector('[data-st-menu][open]');
          sticky.hidden = !show;
          document.body.classList.toggle('st-has-sticky', Boolean(show));
        };
        const scheduleSticky = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(updateSticky);
        };
        window.addEventListener('scroll', scheduleSticky, { passive: true });
        window.addEventListener('resize', scheduleSticky);
        document.querySelectorAll('[data-st-menu]').forEach(menu => menu.addEventListener('toggle', scheduleSticky));
        updateSticky();
      }
    });
    scope.querySelectorAll('[data-st-video-load]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const parent = button.closest('[data-st-video]');
        const template = parent && parent.querySelector('template');
        if (!template) return;
        button.replaceWith(template.content.cloneNode(true));
        const frame = parent.querySelector('iframe'); if (frame) frame.focus();
      });
    });
    scope.querySelectorAll('[data-st-cart-form]').forEach(form => {
      if(form.dataset.ready) return; form.dataset.ready = 'true';
      form.addEventListener('submit', event => {
        if (!event.submitter || event.submitter.name !== 'checkout') return;
        const changed = Array.from(form.querySelectorAll('[name="updates[]"]')).some(input => input.value !== input.dataset.original);
        if (changed) {
          event.preventDefault();
          const update = form.querySelector('[name="update"]');
          if(update) form.requestSubmit(update);
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials:'same-origin' }).then(r => r.ok ? r.json() : null).then(cart => {
      if (cart) document.querySelectorAll('[data-st-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
    }).catch(() => {});
  });
})();
